"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountCreatedStep = void 0;
const react_1 = __importDefault(require("react"));
const organisms_1 = require("../../../components/organisms");
const AccountCreatedStep = () => {
    return (react_1.default.createElement(organisms_1.TimelineEntry, { checked: true, title: "Registrierung abgeschlossen", subTitle: ' ', infoText: "Ihr Account wurde erstellt." }));
};
exports.AccountCreatedStep = AccountCreatedStep;
